import { CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES } from "@highnote/server/src/sdk";

export type Persona = {
  id: string;
  name: string;
  emoji: string;
  sub: string;
  statusSlug: string;
};

export const PERSONAS: Record<string, Persona> = {
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.DAUBREY]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.DAUBREY,
    name: "Draké",
    emoji: "😏",
    sub: "drops petty comments",
    statusSlug: "feelings",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NUPAUL]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NUPAUL,
    name: "NuPaul",
    emoji: "👀",
    sub: "reads your lyrics to filth, darling",
    statusSlug: "ai stuff",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.KLEZRA]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.KLEZRA,
    name: "Klezra Zien",
    emoji: "🤔",
    sub: "sparks thoughtful debate",
    statusSlug: "thoughtful questions",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LAYNE_ZO]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LAYNE_ZO,
    name: "Layne ZoFi",
    emoji: "🎙️",
    sub: "on your breakout interview",
    statusSlug: "interview that definitely happened",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.GIFS]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.GIFS,
    name: "Booski",
    emoji: "🤪",
    sub: "only reacts in gifs",
    statusSlug: "gifs",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NOPRAH]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.NOPRAH,
    name: "Noprah",
    emoji: "📚",
    sub: "leads a critical review",
    statusSlug: "Noprah energy",
  },
  [CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LENDRICK]: {
    id: CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.LENDRICK,
    name: "Lendrick",
    emoji: "👁️",
    sub: "breaks down your lyrics",
    statusSlug: "your third eye",
  },
  KAROKEBOT: {
    id: "lyrics",
    name: "Karaokebot",
    emoji: "🎤",
    sub: "generates a lyrics page",
    statusSlug: "lyric cards",
  },
  BLANK: {
    id: "blank",
    name: "Start blank",
    emoji: "📝",
    sub: "start from scratch",
    statusSlug: "waveform",
  },
};
